import axios from 'axios'
import { CommonSubportionTypeResponse } from '@/api/services/common/subportion-type/common-subportion-type.dto'

class CommonSubportionTypeService {
    async getSubportionTypes(): Promise<CommonSubportionTypeResponse[]> {
        const response = await axios.get<CommonSubportionTypeResponse[]>(`/subportionTypes/`)
        return response.data
    }
}

export const commonSubportionTypeService = new CommonSubportionTypeService()
